export default "/images/24ce8c77c38d2db25d0954cea19ea01f.avif";